import React from 'react';
import Image from 'react-image-enlarger';
import { createGlobalStyle } from 'styled-components';

type ZoomImageProps = {
    src: string;
    style?: Record<string, any>;
    className?: string;
};

const GlobalImageStyles = createGlobalStyle`
    .EnlargedImage__enlarged-container {
        z-index: 1001!important;
    }
    .EnlargedImage__clone {
        padding: 12px;
    }
`;

const ZoomImage = (props: ZoomImageProps): React.ReactElement => {
    const [zoomed, setZoomed] = React.useState(false);

    const handleClickOpen = (): void => setZoomed(true);
    const handleClickClose = (): void => setZoomed(false);

    return (
        <>
            <GlobalImageStyles />

            <Image
                zoomed={zoomed}
                onClick={handleClickOpen}
                onRequestClose={handleClickClose}
                {...props}
            />
        </>
    );
};

export { ZoomImage };
